import { Injectable, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Icons } from '../util/Icons';
import { CustomSerializedName } from '@eadsysteme/articleclient-v1';
import { TranslocoLocaleService } from '@jsverse/transloco-locale';

@Injectable({
	providedIn: 'root',
})
export class ArticlePropertyLocalisationService {
	translocoService = inject(TranslocoService);
	translocoLocaleService = inject(TranslocoLocaleService);
	icons = inject(Icons);

	private locale: string;

	isUpperCase = (string) => /^[A-Z_]*[A-Z_]*$/.test(string);

	constructor() {
		this.locale = this.translocoLocaleService.getLocale();
	}

	public localizeCustomSerializedName(customSerializedNameString: CustomSerializedName | string) {
		let customSerializedName: CustomSerializedName;
		if (typeof customSerializedNameString === 'string' && customSerializedNameString.toString().startsWith('{', 0)) {
			customSerializedName = JSON.parse(customSerializedNameString);
		} else {
			customSerializedName = customSerializedNameString as CustomSerializedName;
		}

		if (customSerializedName?.de && customSerializedName?.en) {
			switch (this.locale) {
				case 'en-EN':
					return this.localizeArticleRow(customSerializedName.en, customSerializedName);
				case 'de-DE':
				default:
					return this.localizeArticleRow(customSerializedName.de, customSerializedName);
			}
		} else if (customSerializedName?.DEFAULT) {
			return this.localizeArticleRow(customSerializedName.DEFAULT, customSerializedName);
		} else if (customSerializedName?.['_default']) {
			return this.localizeArticleRow(customSerializedName['_default'], customSerializedName);
		} else {
			return this.localizeArticleRow(undefined, customSerializedName);
		}
	}

	private localizeArticleRow(localizedCellValue: string, cellValue: CustomSerializedName) {
		if (localizedCellValue !== undefined) {
			return localizedCellValue;
			// TODO Check if cellValue.DEFAULT is valid
		} else if (cellValue && (cellValue.DEFAULT === 'true' || cellValue.DEFAULT === 'false')) {
			return cellValue.DEFAULT === 'true' ? this.translocoService.translate('common.true') : this.translocoService.translate('common.false');
		} else {
			return cellValue;
		}
	}

	translate(articleElement: string): string {
		if (this.isUpperCase(articleElement)) {
			// replace possible enums
			return this.translocoService.translate('enum.' + articleElement);
		} else {
			return articleElement;
		}
	}
}
